import React from 'react';

/**
 * animateTransform HTML for the SVG. React doesn't support the animateTransform element in JSX.
 * See https://facebook.github.io/react/docs/tags-and-attributes.html
 * TODO: Replace with CSS animations. SVG animations are depcreated in Chrome. 
 */
const AnimateTransformHtml = '<animateTransform attributeName="transform" type="rotate" ' +
  'from="0 16 16" to="360 16 16" dur="0.5s" repeatCount="indefinite"></animateTransform>';

/**
 * Component that renders an SVG spinner.
 */
export default class Spinner extends React.Component {
  render() {
    return (
      <svg className="spinner" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" width="50px" height="50px" fill="#2a75a1">
        <path opacity=".25"
          d="M16 0 A16 16 0 0 0 16 32 A16 16 0 0 0 16 0 M16 4 A12 12 0 0 1 16 28 A12 12 0 0 1 16 4" />
        <path d="M16 0 A16 16 0 0 1 32 16 L28 16 A12 12 0 0 0 16 4z"
          dangerouslySetInnerHTML={{__html: AnimateTransformHtml}} />
      </svg>);
  }
}
